module.exports = __webpack_public_path__ + "img/P41.8a1b9754.png";